<!-- 范围选择器 -->
<template>
  <div class="range-picker">
    <p class="range-picker__hd">{{ $t('lang.k_385001') }}</p>
    <div class="range-picker__bd">
      <div class="range-picker-item min">
        <span class="range-picker-item__title">{{ $t('lang.k_385002') }}</span>
        <vh-select
          v-model="minVal"
          class="range-picker-select"
          :placeholder="$t('lang.k_385003')"
          size="small"
        >
          <vh-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="maxVal > 0 && item.value > maxVal"
          ></vh-option>
        </vh-select>
      </div>
      <div class="range-picker-item max">
        <span class="range-picker-item__title">{{ $t('lang.k_385004') }}</span>
        <vh-select
          v-model="maxVal"
          class="range-picker-select"
          :placeholder="$t('lang.k_385005')"
          size="small"
        >
          <vh-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="minVal > 0 && item.value < minVal"
          ></vh-option>
        </vh-select>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        options: []
      };
    },
    props: {
      minRequired: {
        type: Number,
        default: 0
      },
      maxRequired: {
        type: Number,
        default: 0
      },
      total: {
        type: Number,
        default: 0
      }
    },
    watch: {
      total: {
        handler(newVal) {
          this.options = Array.from({ length: this.total + 1 }, (_, index) => ({
            value: index,
            label: index == 0 ? this.$t('lang.k_385006') : this.$t('lang.k_385007', [index]) // 标签文本与value一致
          }));

          if (this.maxVal > newVal) {
            this.maxVal = 0;
          }

          if (this.minVal > newVal) {
          }
        },
        immediate: true
      }
    },
    computed: {
      minVal: {
        get() {
          return this.minRequired;
        },
        set(val) {
          this.$emit('update:minRequired', val);
        }
      },
      maxVal: {
        get() {
          return this.maxRequired;
        },
        set(val) {
          this.$emit('update:maxRequired', val);
        }
      }
    }
  };
</script>
<style lang="less">
  .range-picker {
    margin-top: 10px;

    &__hd {
      font-size: 14px;
      color: #8c8c8c;
    }
    &__bd {
      display: flex;
      flex-direction: row;
      margin-top: 8px;

      .range-picker-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        &__title {
          font-size: 14px;
          color: #8c8c8c;
          padding-right: 4px;
        }
        &.min {
          margin-right: 5px;
        }

        &.max {
          margin-left: 5px;
        }
      }
      .range-picker-select {
        flex: 1;
      }
    }
  }
</style>
